var exports = {
  "J": "xfd349460--44b970--actual",
  "P": "xfd349460--44b970--label",
};

module.exports = exports;
